import React, { useContext, useState, useRef, useEffect } from 'react'
import { Link } from "react-router-dom";
import SessionContext from 'SessionContext'
import { status } from 'hooks/useNotificationsStore';
import { oauthLogout } from 'hooks/useAuthTokens';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { useGlobalState } from "hooks/useGlobalState";

const user_icon = 'data:image/jpeg;base64,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';

export default function UserStatus() {

    const session = useContext(SessionContext);
    const { isGlobalStateSaved, setIsGlobalStateSaved } = useGlobalState();
    const [searchTerm, setSearchTerm] = useState();
    const companies = session.appState.identity.assigned_companies;
    const [showUnsavedModal, setShowUnsavedModal] = useState(false);
    const [selectedName, setSelectedName] = useState();
    const user_name = session.appState.identity.user.name || "";
    const company_name = session.appState.activeCompany.name || "";

    const [isOpen, setIsOpen] = useState(false);
    const [isCompanyListOpen, setIsCompanyListOpen] = useState(false);
    const parentRef = useRef(null);
  
    const handleMouseEnter = () => setIsOpen(true);
    const handleCloseMenu = () => {
        if(!isCompanyListOpen) {
            setIsOpen(false);
        }
    };
    const handleCompanyListEnter = () => setIsCompanyListOpen(true);
    const handleCompanyListLeave = () => setIsCompanyListOpen(false);

    // handle close when user clicks outside the box
    useEffect(() => {
      function handleClickOutside(event) {
        if (parentRef.current && !parentRef.current.contains(event.target)) {
          setIsCompanyListOpen(false);
          setIsOpen(false);
        }
      }

      // event listener when the component mounts
      document.addEventListener("mousedown", handleClickOutside);
        
      // cleanup event listener on unmount
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, []);

    function onChangeCompany(ev) {
        ev.preventDefault();
        setSearchTerm(""); 
        const term = ev.target.value;
        if(isGlobalStateSaved) {
          session.audienceSaved.unsavedAudience(() => x => { onUnsavedCallback(term) });
        } else {
          setSelectedName(term);
          setShowUnsavedModal(true);
        }

    }

    function onUnsavedCallback(name, override = false) {
        if (session.appState.loaded && (isGlobalStateSaved || override)) {
            const company = session.appState.identity.assigned_companies.find(c => c.name === name);
            if (company) {
                setSelectedName("");
                session.notificationsStore.add("Switched to new Company", status.complete, company.name);
                session.crossfilterStore.restoreFromAudience("clear_all");
                session.appState.updateActiveCompany(company);
                setTimeout(() => {
                  window.location.reload();
                }, 300);
            } 
            
        }
    }
    
    function trackChange(e) {
        const value = e.currentTarget.value;
        const cNames = companies.map(company => { return company.name });
        // check if the current value if one of the options we provide, and that it actually changed
        if(value !== searchTerm && cNames.indexOf(value) > -1) {
            // it is!
            // store the value in state and then submit form
            setSearchTerm(value);
            onChangeCompany(e);
        } else {
            // store the value in state
            setSearchTerm(value);   
        }
    }

    function logout(ev){
        ev.preventDefault();
        oauthLogout();
    }

    const confirmedGoBack = () => {
        setIsGlobalStateSaved(true);
        setShowUnsavedModal(false);
        onUnsavedCallback(selectedName, true);
    }

    const userDetails = () => {
        return (<>
            <div className='active-user' title={user_name}>
                {user_name}
            </div>
            <div className='active-company' title={company_name}>
                {company_name}
            </div>
        </>);
    }

    return (
        <div className='user-info'>
          <div className='d-flex justify-content-between align-items-start main-icon gap-2' onMouseEnter={handleMouseEnter}>
            <div className='user-details user-header-display'>
              {userDetails()}
            </div>
            <div>
              <img src={user_icon} alt='User Icon' className='user-icon'/>
            </div>
          </div>

          {isOpen && (
          <div className='user-menu-wrapper' onMouseLeave={handleCloseMenu} ref={parentRef}>
            <div className='user-details user-inside-display d-flex justify-content-between'>
                <div>{userDetails()}</div>
                <div className='edit-user-inside-link'>
                    <div onClick={handleCloseMenu}>
                        <Link to="/profile">
                          Edit User &nbsp; <img src={user_icon} alt='User Icon' className='user-icon'/>
                        </Link>
                    </div>
                </div>
            </div>
            
            <div className='change-companies-wrapper'>
                <div>
                    <form onSubmit={onChangeCompany}>
                        <input list="assigned_companies"
                            onChange={trackChange}
                            value={searchTerm} placeholder='Switch Company'
                            onClick={handleCompanyListEnter} 
                            onBlur={handleCompanyListLeave}/>
                        <datalist id="assigned_companies">
                            {companies.map(c => <option key={c.id} value={c.name} onClick={e => trackChange}/>)}
                        </datalist>
                    </form>
                    <div>
                        <Button onClick={logout} className="logout-button">
                            Logout
                        </Button>
                    </div>
                </div>
            </div>
          </div>)}
          <Modal centered backdrop isOpen={showUnsavedModal}>
            <ModalHeader>
              Unsaved Changes
            </ModalHeader>
            <ModalBody>
              <h6>Your unsaved changes will be lost, continue?</h6>
            </ModalBody>
            <ModalFooter>
              <Button onClick={confirmedGoBack}>Continue</Button>
              <Button className="promote" onClick={() => setShowUnsavedModal(false)}>Return to Editing</Button>
            </ModalFooter>
        </Modal>
        </div>
    );

}



